export default {
  hidden_rates:
    'Algunos métodos de pago también tienen su propia tarifa, establecida por el soporte de tu plataforma. Esas se aplican en lugar de esta tarifa.',
  title: 'Comisiones de procesamiento',
  subtitle:
    'La comisión de procesamiento que se cobra a {{company}} en los pagos online, para cubrir las comisiones de Stripe.',
  card_title: 'Comisión de procesamiento',
  status: {
    inherited_tag: 'Predeterminada del partner',
    inherited: 'A este restaurante se le cobra tu comisión de procesamiento predeterminada.',
    custom_tag: 'Personalizada',
    custom: 'Este restaurante tiene su propia comisión de procesamiento, que sustituye a la predeterminada.',
    none_title: 'No hay comisión de procesamiento establecida',
    none: 'Ni este restaurante ni tu valor por defecto tienen una tarifa. Si no has confirmado un margen del 0 % en la página de comisiones de procesamiento del partner, no puede salir en vivo ni recibir pagos online; con esa confirmación no se le cobra nada y tú pagas las comisiones de Stripe de sus pagos.',
  },
  buttons: {
    set_custom: 'Establecer comisión personalizada',
    edit: 'Editar',
    cancel: 'Cancelar',
    save: 'Guardar',
    reset_to_default: 'Restablecer a predeterminada',
  },
  toasts: {
    load_error: 'No se pudo cargar la comisión de procesamiento.',
    failed_to_save_changes: 'No se pudo guardar la comisión de procesamiento.',
    changes_got_saved: 'Comisión de procesamiento guardada',
    reset_to_default: 'Este restaurante ahora usa tu comisión de procesamiento predeterminada.',
  },
};
